// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsbTwoToneSvg from "@fishx/icons-svg/es/asn/UsbTwoTone";
import FishxIcon from '../components/FishxIcon';

var UsbTwoTone = function UsbTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsbTwoToneSvg
  }));
};

UsbTwoTone.displayName = 'UsbTwoTone';
export default React.forwardRef(UsbTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UsbTwoTone.js
// module id = 4340
// module chunks = 0